<template>
<card :footer="true" :no-padding="true">
  <div class="is-relative">
    <div class="is-ghost">
      <div class="field">
        <template v-if="isViewer">
<!--          <tooltip-button class="btnAction" :no-tooltip="true" tooltip="" @click="contact">-->
<!--            Contact-->
<!--          </tooltip-button>-->
          <tooltip-button v-if="false" class="btnAction" :no-tooltip="true" tooltip="" :isInverted="true" @click="viewJobs">
            View Jobs
          </tooltip-button>
        </template>
        <template v-else>
          <tooltip-button class="btnAction" :no-tooltip="true" tooltip="" @click="viewJobs">
            Your Jobs
          </tooltip-button>
          <tooltip-button class="btnAction" :no-tooltip="true" tooltip="" :isInverted="true" @click="viewApplicants">
            Your Applicants
          </tooltip-button>
        </template>
      </div>
    </div>
  </div>
  <template slot="footer">
    <split-section>
      <template slot="left">
        <div class="has-text-centered">
          <h3 class="title is-3">{{jobsCount}}</h3>
          <h6 class="subtitle title is-7">{{jobs}}</h6>
        </div>
      </template>
      <template slot="right">
        <div class="has-text-centered">
          <h3 class="title is-3">{{applicantsCount}}</h3>
          <h6 class="subtitle title is-7">{{applicants}}</h6>
        </div>
    </template>
    </split-section>
  </template>
</card>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import TooltipButton from '@/components/general/tooltip-button'
import Card from '@/components/general/card'
import SplitSection from '@/components/general/split-section'

export default {
  components: { Card, SplitSection, TooltipButton },
  props: {
    company: {
      type: Object,
      default: () => null
    },
    isViewer: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  watch: {
    async company (newVal) {
      if (newVal) {
        await this.getStats(newVal.id || newVal.companyId)
      }
    }
  },
  methods: {
    ...mapActions('conversations', [
      'getConversationForUser'
    ]),
    ...mapActions('companies', [
      'getStats'
    ]),
    viewJobs () {
      this.$router.push('/admin/jobs')
    },
    viewApplicants () {
      this.$router.push('/admin/applications')
    },
    contact () {
      if (this.isWidget) {
        window.open(`${window.location.origin}/hirer/${this.company.companyId}`, '_blank')
      } else {
        this.getConversationForUser(this.user)
        this.$router.push('/messages')
      }
    }
  },
  computed: {
    ...mapGetters('companies', [
      'stats'
    ]),
    ...mapState('companies', {
      currentJobs: 'jobs'
    }),
    ...mapGetters('users', ['user']),
    isWidget () {
      return !!this.$route.meta.hasOwnProperty('widgetMode')
    },
    jobsCount () {
      return this.currentJobs.length
    },
    applicantsCount () {
      if (this.stats) {
        return this.stats.applications
      } else {
        return 0
      }
    },
    jobs () {
      return this.$t('widget.jobs')
    },
    applicants () {
      return this.$t('widget.applicants')
    }
  },
  async mounted () {
  },
  data: function () {
    return {
      tooltipActive: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
.card {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
}

.is-primary.is-inverted {
  border-color: $primary;
}

.field:not(:last-child) {
  margin-bottom: 1rem;
}

.is-ghost {
  padding: 1rem;

  .btnAction:not(:first-child) {
    margin-top: 16px;
  }
}

.title {
  margin-bottom: 0;
  line-height: normal;
  margin-bottom: 0.75rem;
}

.title.subtitle {
  margin-top: 0;
  line-height: normal;
  margin-bottom: 0rem;
}

.subtitle.title {
  letter-spacing: 2px;
  font-weight: 900;
  text-transform: uppercase;
}

.button {
  display: flex;
  justify-content: space-between;
  padding: 0 1rem;
}

.button.is-primary.is-inverted:hover {
  background-color: rgba(62,207,142,.025)
}
.is-completed {
  width: 100%;
  height: 100%;
  background: rgba(255,255,255, 0.3);
  position: absolute;
  top: 0;
  left: 0;
  cursor: not-allowed;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/profile/hirer/hirer-action-card.vue